import { render, staticRenderFns } from "./ProductDesignFormInput2.vue?vue&type=template&id=566a80a4&"
import script from "./ProductDesignFormInput2.vue?vue&type=script&lang=js&"
export * from "./ProductDesignFormInput2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports